<ng-container *ngIf="!appStatus; else globalStatus">
    <router-outlet>
        <div *ngIf="navLoading$ | async" class="custom-mat-drawer-backdrop">
            <div class="custom-spinner"></div>
        </div>
    </router-outlet>
</ng-container>

<ng-template #globalStatus>
    <div class="center-child">
        <bh-status [state]="appStatus" [message]="statusMessage" [showNote]="showNote"></bh-status>
    </div>
</ng-template>
